import { useState, useEffect } from 'react';
import {
  Badge,
  Nav,
  Container,
  Form,
  Button,
  Offcanvas,
} from 'react-bootstrap';
import {
  FaJenkins,
  FaUserLock,
  FaCartPlus,
  FaBars,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SearchBox from './SearchBox';
import ThemeToggle from './ThemeToggle';
import { useTranslation } from 'react-i18next';
import { useLogoutMutation } from '../slices/usersApiSlice';
import { logout } from '../slices/authSlice';
import '../assets/styles/index.css';
import { setCredentials } from '../slices/authSlice';
import { toast } from 'react-toastify';
import { useLoginMutation } from '../slices/usersApiSlice';
import { removeFromCartLocalStorage } from '../slices/cartSlice';
import { setCredentialLangue } from '../slices/langueSlice';
import { setCredentialDevise } from '../slices/deviseSlice';

const DrawerLink = ({ to, onClick, children, className = '' }) => (
  <Link to={to} className={`drawer-link ${className}`.trim()} onClick={onClick}>
    {children}
  </Link>
);

const HeaderMobile = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [colorFormationPresential, setColorFormationPresential] = useState(
    'formation_presential_green'
  );
  const [colorFormationEnLigne, setColorFormationEnLigne] = useState(
    'formation_EnLigne_purple'
  );
  const [colorAutreProduit, setColorAutreProduit] = useState(
    'autre_produit_purple'
  );
  const [colorPanier, setColorPanier] = useState('panier_red');

  const { cartItems } = useSelector((state) => state.cart);
  const { userInfo } = useSelector((state) => state.auth);
  const { langueInfo } = useSelector((state) => state.langue);
  const { deviseInfo } = useSelector((state) => state.devise);

  const [email] = useState('user@user');
  const [password] = useState('user');
  const [login] = useLoginMutation();
  const [logoutApiCall] = useLogoutMutation();

  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect') || '/';
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const closeMenu = () => setShowMenu(false);

  useEffect(() => {
    if (userInfo) {
      setColorFormationPresential('formation_presential_green');
      setColorPanier('panier_green');
    } else {
      setColorPanier('panier_red');
    }
  }, [userInfo]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const connexion_invite = async () => {
    try {
      setColorFormationPresential('formation_presential_green');
      setColorPanier('panier_green');
      const res = await login({ email, password }).unwrap();
      dispatch(setCredentials({ ...res }));
      closeMenu();
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  const changement_type_produit = (type) => {
    if (type === 1) {
      setColorFormationEnLigne('formation_presential_green');
      setColorFormationPresential('formation_presential_purple');
      setColorAutreProduit('autre_produit_purple');
    } else if (type === 2) {
      setColorFormationEnLigne('formation_presential_purple');
      setColorFormationPresential('formation_presential_purple');
      setColorAutreProduit('autre_produit_green');
    } else if (type === 0) {
      setColorFormationEnLigne('formation_presential_purple');
      setColorFormationPresential('formation_presential_green');
      setColorAutreProduit('autre_produit_purple');
    }
    closeMenu();
  };

  const logoutHandler = async () => {
    try {
      setColorFormationPresential('formation_presential_green');
      setColorPanier('panier_red');
      await logoutApiCall().unwrap();
      dispatch(logout());
      dispatch(removeFromCartLocalStorage());
      navigate('/');
      closeMenu();
    } catch (err) {
      console.log(err);
    }
  };

  const isGuestUser =
    userInfo &&
    userInfo.name === 'User' &&
    !userInfo.isAdmin &&
    !userInfo.isOffice &&
    !userInfo.isFormateur &&
    !userInfo.isVendeur;

  const isClient =
    userInfo &&
    userInfo.name !== 'User' &&
    !userInfo.isAdmin &&
    !userInfo.isOffice &&
    !userInfo.isFormateur &&
    !userInfo.isVendeur;

  return (
    <header>
      <Container fluid className='nav-bar nav-bar-mobile'>
        <button
          type='button'
          className='nav-icon-btn'
          onClick={() => setShowMenu(true)}
          aria-label='Menu'
        >
          <FaBars />
        </button>

        <Link to='/' className='header-brand'>
          <img src='/licorne.png' alt='Licorne Academy' />
          <div className='header-brand-text'>
            <strong>Licorne</strong>
          </div>
        </Link>

        <div className='nav-tools'>
          <ThemeToggle />
          <Nav.Link as={Link} to='/cart' className={`cart-link ${colorPanier}`}>
            <FaCartPlus />
            {cartItems.length > 0 && (
              <Badge pill bg='success'>
                {cartItems.reduce((a, c) => a + c.qty, 0)}
              </Badge>
            )}
          </Nav.Link>
        </div>
      </Container>

      <Container fluid className='nav-mobile-search'>
        <SearchBox />
      </Container>

      <Offcanvas
        show={showMenu}
        onHide={closeMenu}
        placement='start'
        className='nav-drawer'
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <img src='/licorne.png' alt='' width={28} height={28} className='me-2' />
            Licorne
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className='drawer-section'>
            <p className='drawer-section-title'>{t('navProduct')}</p>
            <DrawerLink
              to='/'
              onClick={() => changement_type_produit(0)}
              className={colorFormationPresential}
            >
              {t('navInperson')}
            </DrawerLink>
            <DrawerLink
              to='/online'
              onClick={() => changement_type_produit(1)}
              className={colorFormationEnLigne}
            >
              {t('navOnline')}
            </DrawerLink>
            <DrawerLink
              to='/other'
              onClick={() => changement_type_produit(2)}
              className={colorAutreProduit}
            >
              {t('navOther')}
            </DrawerLink>
          </div>

          <div className='drawer-section'>
            <p className='drawer-section-title'>{t('navCategory')}</p>
            <DrawerLink to='/category/presentiel/info' onClick={closeMenu}>
              {t('info')} — {t('navInperson')}
            </DrawerLink>
            <DrawerLink to='/category/presentiel/devp' onClick={closeMenu}>
              {t('devp')} — {t('navInperson')}
            </DrawerLink>
            <DrawerLink to='/category/online/info' onClick={closeMenu}>
              {t('info')} — {t('navOnline')}
            </DrawerLink>
            <DrawerLink to='/category/online/devp' onClick={closeMenu}>
              {t('devp')} — {t('navOnline')}
            </DrawerLink>
            <DrawerLink to='/category/other/info' onClick={closeMenu}>
              {t('info')} — {t('navOther')}
            </DrawerLink>
            <DrawerLink to='/category/other/devp' onClick={closeMenu}>
              {t('devp')} — {t('navOther')}
            </DrawerLink>
          </div>

          <div className='drawer-section'>
            <p className='drawer-section-title'>{t('language')} / {t('devise')}</p>
            <div className='d-flex gap-2'>
              <Form.Control
                as='select'
                className='header-select flex-grow-1'
                style={{ maxWidth: 'none', minWidth: 0 }}
                value={typeof langueInfo === 'string' ? langueInfo : 'fr'}
                onChange={(e) => {
                  dispatch(setCredentialLangue(e.target.value));
                  changeLanguage(e.target.value);
                }}
              >
                <option value='fr'>Français</option>
                <option value='en'>English</option>
                <option value='ar'>عربي</option>
              </Form.Control>
              <Form.Control
                as='select'
                className='header-select flex-grow-1'
                style={{ maxWidth: 'none', minWidth: 0 }}
                value={typeof deviseInfo === 'string' ? deviseInfo : 'EUR'}
                onChange={(e) => dispatch(setCredentialDevise(e.target.value))}
              >
                <option value='EUR'>EUR</option>
            <option value='USD'>USD</option>
              </Form.Control>
            </div>
          </div>

          <div className='drawer-section'>
            <p className='drawer-section-title'>Compte</p>
            <DrawerLink to='/login' onClick={closeMenu}>
              <FaUserLock className='me-2' /> {t('user')}
            </DrawerLink>

            {!userInfo && (
              <Button
                variant='outline-secondary'
                className='w-100 mt-2 rounded-pill'
                onClick={connexion_invite}
              >
                <FaJenkins /> {t('guest')}
              </Button>
            )}

            {isGuestUser && (
              <button type='button' className='drawer-link drawer-btn' onClick={logoutHandler}>
                {t('Logout')}
              </button>
            )}

            {isClient && (
              <>
                <DrawerLink to='/profile' onClick={closeMenu}>
                  {t('Profile')}
                </DrawerLink>
                <DrawerLink to='/my-courses' onClick={closeMenu}>
                  Mes Formations
                </DrawerLink>
                <DrawerLink to='/my-orders' onClick={closeMenu}>
                  Mes Commandes
                </DrawerLink>
                <button type='button' className='drawer-link drawer-btn' onClick={logoutHandler}>
                  {t('Logout')}
                </button>
              </>
            )}
          </div>

          {userInfo &&
            userInfo.isAdmin &&
            !userInfo.isOffice &&
            !userInfo.isFormateur &&
            !userInfo.isVendeur && (
              <div className='drawer-section'>
                <p className='drawer-section-title'>Admin</p>
                <DrawerLink to='/admin/productlist' onClick={closeMenu}>
                  {t('products')}
                </DrawerLink>
                <DrawerLink to='/admin/orders' onClick={closeMenu}>
                  Commandes (Admin)
                </DrawerLink>
                <DrawerLink to='/admin/click2paytable' onClick={closeMenu}>
                  clic2pay Table
                </DrawerLink>
                <DrawerLink to='/admin/Paypaltable' onClick={closeMenu}>
                  Paypal Table
                </DrawerLink>
                <DrawerLink to='/admin/Stripetable' onClick={closeMenu}>
                  Stripe Table
                </DrawerLink>
                <DrawerLink to='/admin/userlist' onClick={closeMenu}>
                  {t('users')}
                </DrawerLink>
                <DrawerLink to='/admin/cert' onClick={closeMenu}>
                  Certificate Generator
                </DrawerLink>
                <DrawerLink to='/admin/verifycert' onClick={closeMenu}>
                  Certificate Verification
                </DrawerLink>
                <DrawerLink to='/admin/meetings' onClick={closeMenu}>
                  Meet
                </DrawerLink>
                <DrawerLink to='/admin/playlist' onClick={closeMenu}>
                  Playlist
                </DrawerLink>
                <DrawerLink to='/profile' onClick={closeMenu}>
                  {t('Profile')}
                </DrawerLink>
                <button type='button' className='drawer-link drawer-btn' onClick={logoutHandler}>
                  {t('Logout')}
                </button>
              </div>
            )}

          {userInfo &&
            !userInfo.isAdmin &&
            !userInfo.isFormateur &&
            !userInfo.isVendeur &&
            userInfo.isOffice && (
              <div className='drawer-section'>
                <p className='drawer-section-title'>Office</p>
                <DrawerLink to='/office/productlist' onClick={closeMenu}>
                  {t('products')}
                </DrawerLink>
                <DrawerLink to='/office/cert' onClick={closeMenu}>
                  Certificate Generator
                </DrawerLink>
                <DrawerLink to='/office/verifycert' onClick={closeMenu}>
                  Certificate Verification
                </DrawerLink>
                <DrawerLink to='/office/orderlist' onClick={closeMenu}>
                  {t('orders')}
                </DrawerLink>
                <DrawerLink to='/office/click2paytable' onClick={closeMenu}>
                  clic2pay Table
                </DrawerLink>
                <DrawerLink to='/office/Paypaltable' onClick={closeMenu}>
                  Paypal Table
                </DrawerLink>
                <DrawerLink to='/office/Stripetable' onClick={closeMenu}>
                  Stripe Table
                </DrawerLink>
                <DrawerLink to='/profile' onClick={closeMenu}>
                  {t('Profile')}
                </DrawerLink>
                <button type='button' className='drawer-link drawer-btn' onClick={logoutHandler}>
                  {t('Logout')}
                </button>
              </div>
            )}

          {userInfo &&
            !userInfo.isAdmin &&
            !userInfo.isVendeur &&
            !userInfo.isOffice &&
            userInfo.isFormateur && (
              <div className='drawer-section'>
                <p className='drawer-section-title'>Formateur</p>
                <DrawerLink to='/formateur/productlist' onClick={closeMenu}>
                  {t('products')}
                </DrawerLink>
                <DrawerLink to='/formateur/playlist' onClick={closeMenu}>
                  Playlists
                </DrawerLink>
                <DrawerLink to='/formateur/meet' onClick={closeMenu}>
                  Meet
                </DrawerLink>
                <DrawerLink to='/formateur/orders' onClick={closeMenu}>
                  Mes Ventes
                </DrawerLink>
                <DrawerLink to='/profile' onClick={closeMenu}>
                  {t('Profile')}
                </DrawerLink>
                <button type='button' className='drawer-link drawer-btn' onClick={logoutHandler}>
                  {t('Logout')}
                </button>
              </div>
            )}

          {userInfo && !userInfo.isAdmin && userInfo.isVendeur && (
            <div className='drawer-section'>
              <p className='drawer-section-title'>Vendeur</p>
              <DrawerLink to='/vendeur/productlist' onClick={closeMenu}>
                {t('products')}
              </DrawerLink>
              <DrawerLink to='/profile' onClick={closeMenu}>
                {t('Profile')}
              </DrawerLink>
              <button type='button' className='drawer-link drawer-btn' onClick={logoutHandler}>
                {t('Logout')}
              </button>
            </div>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </header>
  );
};

export default HeaderMobile;
